import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { Observable } from 'rxjs';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import type { LlmDefinition } from '@go-modules/interfaces/llm-definition';
import type { AiMarkersEntitlement } from '@go-modules/interfaces/ai-markers-entitlement';

export interface AiPrompt {
	id: number;
	name: string;
	description: string;
	tag: any;
	use_types: any;
	licenses?: any;
	checked?: boolean;
}

export interface Language {
	language_code: string;
	language_name: string;
}

@Injectable({
	providedIn: 'root'
})
export class NgxAiPromptService {
	constructor (
		private http: HttpClient,
		@Inject(selectedServiceToken) public selectedService: SelectedService
	) {}

	public getLlmDefinitions (group): Observable<LlmDefinition[]> {
		return this.http.get<LlmDefinition[]>(`${clientSettings.GoReactV2API}/groups/${group.group_id}/llm-definitions`);
	}

	public getOrgAiMarkersEntitlement (orgId: number): Observable<AiMarkersEntitlement> {
		return this.http.get<AiMarkersEntitlement>(`${clientSettings.GoReactV2API}/orgs/${orgId}/ai-markers/entitlement`);
	}

	public languages (): Observable<Language[]> {
		return this.http.get<Language[]>(`${clientSettings.GoReactV2API}/assembly-ai/supported-languages`);
	}
}
